import React, { useState, useRef, useImperativeHandle, useMemo } from 'react';
import { Tour } from 'antd';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { TabLink } from '@/components';
import Icon from '@/components/Icon';
import { getApplicationUrl } from '@/const/serviceEnv';

import type { MenuDataItem } from '@/const/route.config';

import './index.less';

interface HeaderMenuProps {
  tourFinish?: () => void;
  menuData: MenuDataItem[];
  matchMenuKeys?: string[];
  selectionRouter?: string;
}

export interface HeaderMenuRef {
  setIsTourVisible: (visible: boolean) => void;
}

const HeaderMenu = React.forwardRef<HeaderMenuRef, HeaderMenuProps>(
  ({ menuData, matchMenuKeys = [], tourFinish, selectionRouter }, ref) => {
    const [isTourVisible, setIsTourVisible] = useState(false);
    const navigate = useNavigate();
    const dashboardRef = useRef<HTMLAnchorElement>(null);
    const purchaseRef = useRef<HTMLAnchorElement>(null);
    const shopRef = useRef<HTMLAnchorElement>(null);

    // 暴露方法给父组件
    useImperativeHandle(ref, () => ({
      setIsTourVisible,
    }));

    // 动态计算 steps，确保 DOM 节点存在
    const steps = useMemo(() => {
      return [
        {
          title: '工作台（1/3）',
          description: <div style={{ height: 50 }}>您可以在这里可以查看万鲤平台的新功能以及资讯</div>,
          style: { width: 360 },
          target: () => dashboardRef.current as HTMLElement,
          prevButtonProps: {
            type: 'text',
          },
          nextButtonProps: {
            onClick: () => {
              navigate('/module/showroom/mall');
            },
          },
        },
        {
          title: '万鲤集采（2/3）',
          description: <div style={{ height: 50 }}>璇玑ai智能助手为您提供精准的商品推荐，同时支持直接生成ppt方案</div>,
          style: { width: 360 },
          target: () => purchaseRef.current as HTMLElement,
          prevButtonProps: {
            type: 'text',
            onClick: () => {
              navigate('/module/workbench/dashboard');
            },
          },
          nextButtonProps: {
            onClick: () => {
              selectionRouter && navigate(selectionRouter);
            },
          },
        },
        {
          title: '商城SAAS（3/3）',
          description: <div style={{ height: 50 }}>您可以在这里创建自己的商城，并进行选品</div>,
          style: { width: 360 },
          target: () => shopRef.current as HTMLElement,
          prevButtonProps: {
            type: 'text',
            onClick: () => {
              navigate('/module/showroom/mall');
            },
          },
          nextButtonProps: {
            children: '我知道了',
            onClick: () => {
              navigate('/module/lgjMall/createShop');
            },
          },
        },
      ];
    }, [selectionRouter]);

    const getTourRef = (path: string) => {
      switch (path) {
        case '/group/workbench':
          return dashboardRef;
        case '/module/showroom/mall':
          return purchaseRef;
        case '/group/shop':
          return shopRef;
        default:
          return null;
      }
    };

    return (
      <div className="fle-layout-header-menu">
        {menuData
          .filter((item) => !item.hideInMenu && item.path !== '/group/console')
          .map((item) => {
            const { menuTag } = JSON.parse(decodeURIComponent(item?.props || '{}'));

            return item.name ? (
              <TabLink
                key={item.path}
                className={classNames('fle-layout-header-menu-item', {
                  active: matchMenuKeys.includes(item.path || ''),
                })}
                to={item.redirect || item.path}
                ref={getTourRef(item.path)}
              >
                
                <span className="fle-layout-header-menu-item-name">{item.name}</span>
              </TabLink>
            ) : null;
          })}
          {/* <TabLink
            key={getApplicationUrl('newFleAI')}
            className="fle-layout-header-menu-item"
            to={getApplicationUrl('newFleAI')}
            target="_blank"
          >
            <span className="fle-layout-header-menu-item-name">
              <Icon type="icon-13-sikao" style={{ fontSize: 16 }} />
              <span className="fle-layout-header-menu-item-name-fleai">FleAI</span>
            </span>
          </TabLink> */}
        {/* <Tour
          open={isTourVisible}
          steps={steps as any}
          onFinish={tourFinish}
          onClose={() => setIsTourVisible(false)}
          gap={{ offset: [10, 0], radius: 0 }}
          indicatorsRender={() => (
            <span
              onClick={() => setIsTourVisible(false)}
              style={{ color: '#bbb', lineHeight: '22px', cursor: 'pointer' }}
            >
              跳过
            </span>
          )}
        /> */}
      </div>
    );
  },
);

HeaderMenu.displayName = 'HeaderMenu';

export default HeaderMenu;
